export const TIME_FORMATS = duration => ({
  MIN_AGO: `${duration} [min ago]`,
  HOUR_AGO: `${duration} [hour ago]`,
  HOURS_AGO: `${duration} [hours ago]`,
  DAY_AGO: `${duration} [day ago at] h:mma`,
  DAYS_AGO: `${duration} [days ago at] h:mma`,
  DATETIME: "MMM DD, YYYY h:mma",
})
